import React from 'react';
import { getProductIconComponent, resolveProductIconColor } from '../utils/productIcons';

/**
 * Renders a catalog product icon (react-icons/fa) with themed color.
 */
export default function ProductIcon({
  iconKey,
  iconColor,
  size = 'md',
  className = '',
  centered = false
}) {
  const Icon = getProductIconComponent(iconKey);
  const color = resolveProductIconColor(iconColor);
  const sizeClass = size === 'lg' ? 'product-icon-lg' : 'product-icon-md';

  return (
    <div
      className={`product-icon-wrap ${sizeClass} ${centered ? 'product-icon-centered' : ''} ${className}`.trim()}
      style={{ '--product-icon-color': color }}
      aria-hidden
    >
      <Icon className="product-icon-glyph" />
    </div>
  );
}
